<template>
  <div>
    <BaseTitle :title="$t(edit ? 'content.edit_category' : 'content.add_category')" />
    <v-row>
      <v-col cols="12" md="12">
        <form @submit.prevent="submit">
          <v-card class="mb-8">
            <div class="pa-8" v-if="type === 'teacher'">
              <v-row>
                <v-col md="6">
                  <form-group :name="$t('content.category_name')" :validator="$v.form.categoryName">
                    <template slot-scope="{ attrs }">
                      <v-text-field
                        v-model="form.categoryName"
                        v-bind="attrs"
                        :label="$t('content.category_name')"
                        @input="$v.form.categoryName.$touch()"
                        @blur="$v.form.categoryName.$touch()"
                      />
                    </template>
                  </form-group>
                </v-col>
                <v-col md="3">
                  <form-group :name="$t('content.max_value')" :validator="$v.form.valueMax">
                    <template slot-scope="{ attrs }">
                      <v-text-field
                        v-model="form.valueMax"
                        @blur="$v.form.valueMax.$touch()"
                        @input="$v.form.valueMax.$touch()"
                        :min="0"
                        type="number"
                        v-bind="attrs"
                        :label="$t('content.max_value')"
                        v-number
                        @paste="onPaste"
                      />
                    </template>
                  </form-group>
                </v-col>
                <v-col md="3">
                  <form-group :name="$t('content.min_value')" :validator="$v.form.valueMin">
                    <template slot-scope="{ attrs }">
                      <v-text-field
                        v-model="form.valueMin"
                        @blur="$v.form.valueMin.$touch()"
                        :min="0"
                        type="number"
                        v-bind="attrs"
                        :label="$t('content.min_value')"
                        @input="maximum($event)"
                        v-number
                        @paste="onPaste"
                      />
                    </template>
                  </form-group>
                </v-col>
              </v-row>
              <div class="app-section-title mb-6">{{ $t('form.desc') }}</div>
              <form-group>
                <template slot-scope="{ attrs }">
                  <text-editor v-bind="attrs" v-model="form.description" />
                </template>
              </form-group>
              <div v-if="form.description" class="app-section-title mb-5">{{ $t('form.desc') }}</div>
              <div v-if="form.description" style=" border: 1px solid #d8d8d8;border-radius: 8px 8px 8px 8px;" class="pa-5">
                <article v-if="form.description" v-html="form.description" />
                <span v-else>-</span>
              </div>
            </div>
            <div class="pa-8" v-else>
              <v-row>
                <v-col md="12">
                  <form-group :name="$t('content.category_name')" :validator="$v.form.categoryName">
                    <template slot-scope="{ attrs }">
                      <v-text-field
                        v-model="form.categoryName"
                        v-bind="attrs"
                        :label="$t('content.category_name')"
                        @input="$v.form.categoryName.$touch()"
                        @blur="$v.form.categoryName.$touch()"
                      />
                    </template>
                  </form-group>
                </v-col>
              </v-row>
            </div>
          </v-card>
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" @click="submit" :loading="loading">
              {{ $t('submit') }}
            </v-btn>
          </div>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TextEditor from '@/components/base/TextEditor.vue';
import BaseTitle from '@/components/base/Title';
import { maxLength } from 'vuelidate/lib/validators';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

export default {
  name: 'CreateEditCategoryTeacherStudent',
  components: {
    BaseTitle,
    TextEditor
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    }
  },
  validations() {
    return {
      form: {
        categoryName: { required, maxLength: maxLength(30) },
        valueMin: this.type === 'teacher' ? { required } : '',
        valueMax: this.type === 'teacher' ? { required } : '',
        description: this.type === 'teacher' ? { required } : ''
      }
    };
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      tokenBearer: 'Auth/token',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    })
  },
  data: () => ({
    form: {
      categoryName: '',
      valueMin: '',
      valueMax: '',
      description: ''
    },
    loadingButton: false,
    dataClass: '',
    loading: false,
    edit: false
    // series: [
    //   {
    //     name: 'Scores',
    //     data: [80, 50, 30, 40, 100, 20]
    //   }
    // ],
    // chartOptions: {
    //   chart: {
    //     height: 350,
    //     type: 'radar'
    //   },
    //   dataLabels: {
    //     enabled: true
    //   },
    //   plotOptions: {
    //     radar: {
    //       size: 140,
    //       polygons: {
    //         strokeColors: '#e9e9e9',
    //         fill: {
    //           colors: ['#f8f8f8', '#fff']
    //         }
    //       }
    //     }
    //   },
    //   title: {
    //     text: 'Pentagon Report'
    //   },
    //   colors: ['#FF4560'],
    //   markers: {
    //     size: 4,
    //     colors: ['#fff'],
    //     strokeColor: '#FF4560',
    //     strokeWidth: 2
    //   },
    //   tooltip: {
    //     y: {
    //       formatter: function(val) {
    //         return val;
    //       }
    //     }
    //   },
    //   xaxis: {
    //     categories: ['Science', 'Art', 'Sport', 'Math', 'Social', 'English']
    //   },
    //   yaxis: {
    //     tickAmount: 7,
    //     labels: {
    //       formatter: function(val, i) {
    //         if (i % 2 === 0) {
    //           return val;
    //         } else {
    //           return '';
    //         }
    //       }
    //     }
    //   }
    // }
    // series: [
    //   {
    //     name: 'Score',
    //     data: [10, 41, 80, 60]
    //   }
    // ],
    // chartOptions: {
    //   chart: {
    //     height: 350,
    //     type: 'line',
    //     zoom: {
    //       enabled: false
    //     }
    //   },
    //   dataLabels: {
    //     enabled: false
    //   },
    //   stroke: {
    //     curve: 'straight'
    //   },
    //   title: {
    //     text: 'Average Score',
    //     align: 'left'
    //   },
    //   grid: {
    //     row: {
    //       colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
    //       opacity: 0.5
    //     }
    //   },
    //   xaxis: {
    //     categories: ['Math', 'English', 'Arab', 'Korean']
    //   },
    //   yaxis: {
    //     max: 100
    //   }
    // }
  }),
  methods: {
    onPaste(evt) {
      if (evt) {
        evt.preventDefault();
      }
    },
    maximum(e) {
      if (Number(e) >= Number(this.form.valueMax)) {
        this.$nextTick(() => {
          this.form.valueMin = this.form.valueMax - 1;
        });
      }
      this.$v.form.valueMin.$touch();
    },
    getData() {
      this.$store
        .dispatch(`Analytical/${this.type === 'teacher' ? 'getListCategoryById' : 'getListCategoryStudentById'}`, this.$route.params.idCategory)
        .then(ras => {
          Object.keys(this.form).forEach(form => {
            this.form[form] = ras[form];
          });
        });
    },
    submit() {
      if (!this.form.description && this.type === 'teacher') {
        this.$store.dispatch('general/showErrorNotification', { message: 'Description Required' });
      }
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      this.loading = true;
      const payload = { ...(this.edit ? { id: this.$route.params.idCategory } : null), ...this.form };

      this.$store
        .dispatch(
          `Analytical/${
            this.edit && this.type === 'teacher'
              ? 'updateCategory'
              : !this.edit && this.type === 'teacher'
              ? 'createCategory'
              : this.edit && this.type === 'student'
              ? 'updateCategoryStudent'
              : 'createCategoryStudent'
          }`,
          payload
        )
        .then(() =>
          this.$router.push({
            name:
              this.edit && this.type === 'teacher'
                ? 'CategoryTeacherSuccessUpdate'
                : !this.edit && this.type === 'teacher'
                ? 'CategoryTeacherSuccess'
                : this.edit && this.type === 'student'
                ? 'CategoryStudentSuccessUpdate'
                : 'CategoryStudentSuccess'
          })
        )
        .finally(() => (this.loading = false));
    },
    back() {
      if (this.type === 'teacher') {
        this.$router.push({ name: 'AnalyticTeacherListID', params: { idSidebar: 1 } });
      } else {
        this.$router.push({ name: 'AnalyticStudentListID', params: { idSidebar: 1 } });
      }
    }
  },
  created() {
    if (this.$route.params.idCategory) {
      this.getData();
      this.edit = true;
    }
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

body {
  height: 100%;
}
</style>
